export default "__VITE_ASSET__D0QGdm5O__"